<template>
  <div  class="guest">
    <!-- tab -->
    <div style="backgroundColor: #ffffff;">
      <div class="tabs">
        <div @click="tabItemClick(0)" :class="['tab_item', tabIndex == 0 && 'active']">待审批</div>
        <div @click="tabItemClick(1)" :class="['tab_item', tabIndex == 1 && 'active']">已审批</div>
      </div>
    </div>
    <div style="height: 1vh"></div>
    <!-- 列表 -->
    <div class="guestList" :style="{height: tabIndex == 1 && '91vh'}"  v-if="guestOrderList.length > 0">
      <van-list
        v-model="listLoading"
        :finished="finished"
        finished-text="暂无更多数据"
        :offset="150"
        
        @load="scroll"
      >
      <div class="guestList_item_box" @click="$router.push({path: '/orderdetail', query: {index}})" v-for="(item, index) in guestOrderList" :key="item.guestOrderId">
        <div class="guestList_item"   >
          <div :class="['info2']">
            <div class="info_tr">
              <span>车牌号码</span>
              <span style="font-weight: bolder;">：{{ item.plate }}</span>
            </div>
            <div class="info_tr">
              <span>工号</span>
              <span>：{{ item.personCode }}</span>
            </div>
            <div class="info_tr">
              <span>姓名</span>
              <span>：{{ item.personName }}</span>
            </div>
           
            <div class="info_tr">
              <span>起始时间</span>
              <span>：{{ item.beginTime }}</span>
            </div>
            <div class="info_tr">
              <span>结束时间</span>
              <span>：{{ item.endTime }}</span>
            </div>
            <div class="info_tr">
              <span>登记时间</span>
              <span>：2023-03-18 10:11:23</span>
            </div>
          
            <!-- <div class="info_tr">
              <span>预约结果</span>
              <font style="color: #5e5d5d">：</font>
              <span style="color: green; font-size: 16px" v-if="item.status == 1">预约成功</span>
              <span style="font-size: 16px; color: #666" v-if="item.status == 0">待审批</span>
              <span style="color: red; font-size: 16px" v-if="item.status == -1">预约失败</span>
            </div> -->
          </div>
        </div>
      </div>
      </van-list>
    </div>
    <van-empty v-else image="search" description="暂无数据" />
    
    
  </div>
</template>

<script>
const Dayjs = require("dayjs");
import { getMyOrder, getMyToDo } from '@/api/order'
// import { getGuestOrderDetail,  } from '@/api/guestOrder'
import { getTokenName } from '@/utils/auth'
export default {
  data () {
    return {
      tabIndex: 0,
      apiList: [ getMyToDo, getMyOrder ],
      guestOrderList: [],
      page: 1,
      total: 0,
      baseUrl: process.env.VUE_APP_API_BASE_URL == '/' ? location.origin : process.env.VUE_APP_API_BASE_URL,
      token: '',
      listLoading: false,
      finished: false
    }
  },
  mounted () {
    this.token = sessionStorage.getItem(getTokenName())
  },  
  created () {
    if(localStorage.getItem('carList')) {
      this.guestOrderList = JSON.parse(localStorage.getItem('carList'))
    }
    console.log(this.guestOrderList, 'guestOrderList');

  },
  activated () {
    // this.guestOrderList = []
    this.page = 1
    // this.getMyToDo()
  },
  filters: {
    // 时间格式化
    timeFilter (val) {
      if (val) {
        return Dayjs(val).format('YYYY/MM/DD')
      }
    },
    // 身份证脱敏
    idcardFilter (val) {
      if (val && val.length > 5) {
        let str1 = val.substring(0, 2)
        let str2 = val.substring(val.length - 3, val.length)
        for (let index = 0; index < val.length - 5; index++) {
          str1 += '*'
        }
        return str1  + str2
      } else {
        return val
      }
    }, 
  },
  methods: {
   
    // 获取访客用户
    getMyToDo () {
      this.apiList[this.tabIndex]({page: this.page, limit: 10}).then(res => {
        if(res.code === 0) {
          
          this.guestOrderList.push(...guestList)
          if (res.page.list.length) {
            this.finished = false
          } else {
            this.finished = true
          }
          this.listLoading = false
          
          this.total = res.page.totalCount
        }else{
          this.$toast.fail(res.msg)
        }
      }).catch(err => {
        console.error(err, 'err');
        this.$toast.fail('请求失败')
      })
    },
    // 滚动到底部
    scroll () {
      
      if (this.guestOrderList.length < this.total) {
        this.listLoading = true
        this.page += 1
        this.getMyToDo()
      } else {
        this.finished = true
      }
    },  
    tabItemClick (index) {
      if (index !=  this.tabIndex) {
        this.tabIndex = index
        // this.guestOrderList = []
        this.finished = true
        this.page = 1
        // this.getMyToDo()
        if (this.tabIndex == 0) {
          if(localStorage.getItem('carList')) {
            this.guestOrderList = JSON.parse(localStorage.getItem('carList'))
          }
        } else {

          this.guestOrderList = this.guestOrderList.filter((item, index) => index % 2 === 0)
        }

      }
    }
  }
}
</script>
<style scoped lang="less">
@import './addverify.less';
/deep/ .van-popup {
  width: 80% !important;
  padding: 15px 10px;
 
}
.stopCar {
position: absolute;
top: 0;
right: 0;
padding: 8px 13px;
background-color: #1989fa;
color: #fff;
border-radius: 3px;
font-size: 12px;
opacity: .8;
}

</style>
